import { Color, TextStyle } from '@tiptap/extension-text-style';

/** Accepts legacy `<font color>` markup, which Gmail uses in pasted signatures. */
export const FontTagTextStyle = TextStyle.extend({
  parseHTML() {
    return [
      ...(this.parent?.() ?? []),
      {
        tag: 'font',
        consuming: false,
        getAttrs: (element) =>
          (element as HTMLElement).hasAttribute('color') ? {} : false,
      },
    ];
  },
});

export const FontTagColor = Color.extend({
  addGlobalAttributes() {
    return (this.parent?.() ?? []).map((group) => {
      const color = group.attributes.color;
      if (!color) return group;
      return {
        ...group,
        attributes: {
          ...group.attributes,
          color: {
            ...color,
            parseHTML: (element: HTMLElement) =>
              color.parseHTML?.(element) || element.getAttribute('color') || null,
          },
        },
      };
    });
  },
});
